import { FunctionComponent, useContext } from 'react'
import contextToiTeaser from '@contexts/toiTeaser'
import ToiTeaserComponents from '@components/Teaser/Toi'
import { getVideoData } from '../utils'
import { TeaserVideo } from '../types'

interface TeaserVideoInfoProps {
  video?: TeaserVideo
  isInPromo?: boolean
  isStandalone: boolean
}

const { TOITeaserLayoutContext } = contextToiTeaser

const { VideoInfo } = ToiTeaserComponents

const TeaserVideoInfo: FunctionComponent<TeaserVideoInfoProps> = ({
  isStandalone,
  isInPromo,
  video,
}) => {
  const { articleType, mainTextAlignment } = useContext(TOITeaserLayoutContext)

  const videoData = getVideoData(video)
  const isLive = videoData?.duration === -1

  if (!videoData) {
    return null
  }

  if (articleType !== 'default') {
    if (mainTextAlignment.h === 'right') {
      if (isStandalone) {
        return null
      }
    } else {
      if (!isStandalone) {
        return null
      }
    }
  }

  return (
    <VideoInfo
      isStandalone={isStandalone}
      isInPromo={isInPromo}
      isOpinion={articleType !== 'default'}>
      {isLive ? 'LIVE' : videoData.formattedDuration}
    </VideoInfo>
  )
}

export default TeaserVideoInfo
